/**
 * Category Badge Styles
 *
 * Shared styling utilities for project category badges.
 * Used across project cards, modals, and other components.
 */

/** Project category types */
export type ProjectCategory = "residential" | "commercial" | "hospitality";

/**
 * Get the badge className for a given project category
 */
export function getCategoryBadgeClassName(category: ProjectCategory): string {
	switch (category) {
		case "residential":
			return "bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300 border-blue-200 dark:border-blue-800";
		case "commercial":
			return "bg-purple-100 text-purple-800 dark:bg-purple-900/50 dark:text-purple-300 border-purple-200 dark:border-purple-800";
		case "hospitality":
			return "bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300 border-green-200 dark:border-green-800";
		default:
			return "";
	}
}

/**
 * Format category name for display (capitalize first letter)
 */
export function formatCategoryName(category: string): string {
	return category.charAt(0).toUpperCase() + category.slice(1);
}
